import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type FolderConnectSyncState = {
  syncs: Record<number, string>;
};

const initialState: FolderConnectSyncState = {
  syncs: {},
};

const folderConnectSyncSlice = createSlice({
  name: "folderConnectSync",
  initialState,
  reducers: {
    startFolderConnectSync: (
      state,
      action: PayloadAction<{ folderId: number; folderName: string }>,
    ) => {
      state.syncs[action.payload.folderId] = action.payload.folderName;
    },
    removeFolderConnectSync: (
      state,
      action: PayloadAction<{ folderId: number }>,
    ) => {
      delete state.syncs[action.payload.folderId];
    },
  },
});

export const { startFolderConnectSync, removeFolderConnectSync } =
  folderConnectSyncSlice.actions;
export default folderConnectSyncSlice.reducer;
